import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import { IconButton, TextField } from '@mui/material';
import classNames from 'classnames';
import dayjs from 'dayjs';
import numeral from 'numeral';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { removeSavedLocationShape } from '../api/locations';
import { LocationsContext } from '../context/locations';
import { LocationShapes } from '../core/global';
import { isNumber } from '../helpers/core';
import styles from "../styles/components/saved-locations-shapes-item.module.scss";
import { ColorSwatch } from './color-picker';
import { DeleteConfirmation, EditSaveConfirmation } from './confirmation-buttons';

interface LocationShapeItemProps {
  data: LocationShapes
  onUpdate: () => void
}

export const LocationShapeItem = ({
  data,
  onUpdate,
}: LocationShapeItemProps) => {
  const [editIsActive, setEditIsActive] = useState(false)
  const [title, setTitle] = useState('')
  const [deleteActive, setDeleteActive] = useState(false)

  const { setNotSavedYetLocationShapes, updateShape } = useContext(LocationsContext);

  useEffect(() => {
    setTitle(data?.title || '')
  }, [data])

  const [lat, lon] = useMemo(() => {
    if (data) {
      if (data.data && data.data.features && Array.isArray(data.data.features) && data.data.features.length > 0) {  
        const {geometry} = data.data.features[0]
        if (geometry) {
          const {coordinates, type} = geometry
          if (type && type === 'Point' && coordinates && Array.isArray(coordinates) && coordinates.length === 2) {
            return [coordinates[1], coordinates[0]]
          }
          
        }
        
      }
    }
    return [null,null]
  }, [data])
  
  const onUpdateShape = useCallback(async ({color: newColor, title: newTitle, hidden}: {color?: string, title?: string, hidden?: boolean}) => {
    const uid = data?.uid || undefined
    // const color = data?.color || null
    if (newColor) {
      updateShape({uid, color: newColor})
    } else if (newTitle) {
      updateShape({uid, title: newTitle})
    } else if (typeof hidden === "boolean") {
      updateShape({uid, hidden})
    }
  }, [data, title])

  return (
    <>
      <div className={classNames(styles.itemWrapper, {
        [styles.deleteActive]: deleteActive
      })}>
        <div className={classNames(styles.row, styles.firstColumn)}>
          <ColorSwatch 
            onChangeColour={async (newColor: string) => {
              onUpdateShape({color: newColor})
            }}
            size="medium" 
            color={data?.color || '#ffffff'} 
          />
          {editIsActive ?
            <div className={styles.column}>
              <TextField
                id="title"
                name="title"
                label="Location title"
                value={title}
                autoFocus
                size="small"
                fullWidth
                variant="outlined"
                onChange={(event: React.SyntheticEvent) => {
                  // @ts-ignore
                  setTitle(event.currentTarget.value)
                }}
                onKeyUp={(event: React.KeyboardEvent) => {
                  // check for enter
                  // if (event.key === 'Enter') {
                    // onUpdateShape({title})
                    // saveUpdates(itemProjectId, fieldTitle)
                  // }
                }}
                // onClick={() => {
                  // setDatePickerOpen(true)
                // }}
                // color={titleError ? 'error' : 'primary'}
              />
            </div>
          :
            <div className={styles.column}>
              <p> {title}, {data.source}
                {isNumber(lat) && isNumber(lon) && <>, point: <strong>lat:</strong> {numeral(lat).format("0.00000")}, <strong>lon:</strong> {numeral(lon).format("0.00000")}</>}
              </p>
              <p>Created: {data.created_at && dayjs(data.created_at).format("DD/MM/YY")}</p>
            </div>
          }
        </div>
        <div className={styles.row}>
          <IconButton
            aria-label="Toggle shape visibility"
            onClick={()=> {
              onUpdateShape({hidden: data?.hidden ? false : true})
            }}
          >
            {!data?.hidden ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
          </IconButton>
          {!deleteActive &&  <EditSaveConfirmation
            showButton
            onCancel={() => {
              setEditIsActive(false)
              setTitle(data?.title || '')
            }}
            onSave={async () => {
              setEditIsActive(false)
              onUpdateShape({title})
            }}
            onActive={() => {
              setEditIsActive(true)
            }}
          />}

          {!editIsActive && <DeleteConfirmation
              onCancel={() => {
                setDeleteActive(false)
              }}
              onActive={() => {
                setDeleteActive(true)
              }}
              onDelete={async () => {
                const exec = async () => {
                  if (data?.uid) {
                    await removeSavedLocationShape({uid: data?.uid})
                    onUpdate()
                  } else if (data?.created_at) {
                    setNotSavedYetLocationShapes((loc: LocationShapes[] | null) => {
                      const useLoc = loc !== null ? [...loc] : []
                      return useLoc.filter(l => l.created_at !== data?.created_at)
                    })
                    onUpdate()
                  }
                }
                exec()
              }}
            />
          }
        </div>
      </div>
    </>
  )
}
